import React from "react";
import { MoData } from "../../utils/types";

interface MessageDetailsModalProps {
  selectedRow: MoData | null;
  setSelectedRow: (row: MoData | null) => void;
}

const MessageDetailsModal: React.FC<MessageDetailsModalProps> = ({
  selectedRow,
  setSelectedRow,
}) => {
  if (!selectedRow) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-full sm:max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="p-4 sm:p-6 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
            Message Details
          </h2>
          <button
            onClick={() => setSelectedRow(null)}
            className="text-gray-500 hover:text-gray-700 text-xl font-medium"
          >
            &times;
          </button>
        </div>
        <div className="p-4 sm:p-6 space-y-4">
          <div className="flex justify-end">
            <div className="bg-blue-100 rounded-lg p-3 max-w-[80%]">
              <p className="text-sm text-gray-800 font-medium">
                MO: {selectedRow.mo}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Sent at {new Date(selectedRow.created_at).toLocaleString()}
              </p>
            </div>
          </div>
        </div>
        <div className="p-4 sm:p-6 border-t border-gray-200 flex justify-end">
          <button
            onClick={() => setSelectedRow(null)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageDetailsModal;
